import { render, staticRenderFns } from "./MovableTextBoxInputMethodEditor.vue?vue&type=template&id=31a91712&scoped=true&"
import script from "./MovableTextBoxInputMethodEditor.vue?vue&type=script&lang=ts&"
export * from "./MovableTextBoxInputMethodEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a91712",
  null
  
)

export default component.exports